import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import CadastrarInsumoRecord from '@components/InsumoRecord/CadastrarInsumoRecord';
import formatMessage from './i18n/formatMessage';
import Insumo from '@resources/InsumosEnum';
import { withRouter } from 'react-router-dom';

/**
 * Tela para cadastro de bactericidas microbiológicos
 *
 * @author Gabriela Farias <gabriela.farias@kepha.com.br>
 * @param {*} props
 * @returns {JSX.Element}
 */
function EditarBactericidasMicrobiologicos(props) {
  useEffect(() => {
    const title = 'bactericidasMicrobiologicos.cadastroDeBactericidasMicrobiologicos';
    if (props.itensState.name !== title) {
      props.dispatch({ type: 'UPDATE_TOOLBAR', toolbar: formatMessage(title), name: title });
    }
  }, []);

  return (
    <CadastrarInsumoRecord
      id={props.match.params.id}
      insumoURL={'bactericidas-microbiologicos'}
      insumoEnum={Insumo.BACTERICIDA_MICROBIOLOGICO}
      infoUsuario={props.infoUsuario}
      saveMessage={formatMessage(
        'bactericidasMicrobiologicos.' +
          (props.match.params.id
            ? 'bactericidasMicrobiologicosEditadoComSucesso'
            : 'bactericidasMicrobiologicosCadastradoComSucesso')
      )}
      falhaSaveMesssage={formatMessage(
        'bactericidasMicrobiologicos.' +
          (props.match.params.id
            ? 'falhaAoEditarBactericidasMicrobiologicos'
            : 'falhaAoCadastrarBactericidasMicrobiologicos')
      )}
      falhaCarregarMensagem={formatMessage('bactericidasMicrobiologicos.falhaAoCarregarBactericidasMicrobiologicos')}
    />
  );
}

const mapStateToProps = state => ({
  itensState: state.toolbar,
  infoUsuario: state.adicionarInfoUsuario.info
});

export default withRouter(connect(mapStateToProps)(EditarBactericidasMicrobiologicos));
